<template>
  <CFooter :fixed="false">
    <div>
      <a href="https://www.quantiumsys.com" target="_blank">Quantium Systems</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} inc.</span>
    </div>
    <div class="ml-auto">
      <span class="mr-1" target="_blank">Pour </span>
      <a href="https://sentinellenord.ulaval.ca">Sentinelle Nord</a> - Concentrateur de messages IOT - <a href="https://www.ulaval.ca">Université Laval</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
